import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  product: {},
  isLoading: false,
  error: null
};

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProductDetails: (state, action) => {
      return action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setLoading: (state) => {
      state.isLoading = true;
    }
  }
});

export const { setProductDetails, setLoading, setError } = productSlice.actions;

export default productSlice.reducer;
